import { format, parseISO } from 'date-fns';
import { id as localeId } from 'date-fns/locale';

export const SIZES = [
  'S', 'M', 'L', 'XL', 'XXL', 'ALL SIZE', 'STANDAR', 'JUMBO',
  'S (1-2 TH)', 'M (3-4 TH)', 'L (5-6 TH)', 'XL (7-8 TH)', 'XXL (9-10 TH)', 'XXXL (11-12 TH)',
];

export const formatIDR = (n) => 'Rp' + Math.round(Number(n) || 0).toLocaleString('id-ID');

export const formatDate = (d) => {
  if (!d) return '-';
  try {
    return format(parseISO(d), 'd MMM yyyy', { locale: localeId });
  } catch {
    return d;
  }
};

export const formatDateLong = (d) => {
  if (!d) return '-';
  try {
    return format(parseISO(d), 'EEEE, d MMMM yyyy', { locale: localeId });
  } catch {
    return d;
  }
};

export const formatTime = (iso) => {
  if (!iso) return '';
  try {
    return format(parseISO(iso), 'HH:mm');
  } catch {
    return '';
  }
};

export const todayStr = () => format(new Date(), 'yyyy-MM-dd');

export const shiftDateStr = (iso, days) => {
  const d = new Date(iso + 'T00:00:00');
  d.setDate(d.getDate() + days);
  return format(d, 'yyyy-MM-dd');
};

export const formatSizes = (sizes) =>
  Object.entries(sizes || {})
    .filter(([, q]) => q > 0)
    .map(([s, q]) => `${s}:${q}`)
    .join(' · ');

export const PAY_STATUS = {
  lunas: { label: 'Lunas', cls: 'bg-success/10 text-success' },
  dp: { label: 'DP', cls: 'bg-caramel/20 text-[#8a5a2e]' },
  belum_bayar: { label: 'Belum Lunas', cls: 'bg-danger/10 text-danger' },
};

export const TX_STATUS = {
  active: { label: 'Aktif', cls: 'bg-brown/10 text-brown' },
  completed: { label: 'Selesai', cls: 'bg-neutral-200/70 text-neutral-600' },
  cancelled: { label: 'Dibatalkan', cls: 'bg-danger/10 text-danger' },
};

export const BARANG_STATUS = {
  overdue: { label: 'Telat', cls: 'bg-danger/10 text-danger' },
  due_today: { label: 'Kembali hari ini', cls: 'bg-warning/15 text-[#8a5f1e]' },
  due_tomorrow: { label: 'Kembali besok', cls: 'bg-caramel/20 text-[#8a5a2e]' },
  out: { label: 'Sedang disewa', cls: 'bg-brown/10 text-brown' },
  booked: { label: 'Terjadwal', cls: 'bg-gold/20 text-gold-dark' },
  belum_lengkap: { label: 'Belum lengkap', cls: 'bg-warning/20 text-[#8a5f1e]' },
  laundry: { label: 'Di laundry', cls: 'bg-orange-100 text-orange-700' },
  done: { label: 'Selesai', cls: 'bg-success/10 text-success' },
  cancelled: { label: 'Dibatalkan', cls: 'bg-danger/10 text-danger' },
};

export const SOURCES = [
  { value: 'Iklan Ads', label: 'Iklan Ads' },
  { value: 'Instagram', label: 'Instagram' },
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'TikTok', label: 'TikTok' },
  { value: 'Teman/Keluarga', label: 'Teman/Keluarga' },
  { value: 'Repeat Order', label: 'Repeat Order' },
  { value: 'Walk-in / Spanduk', label: 'Walk-in / Spanduk' },
  { value: 'Lainnya', label: 'Lainnya' },
];

export const sourceLabel = (v) => SOURCES.find((s) => s.value.toLowerCase() === String(v).toLowerCase())?.label || v;

export const PAY_METHODS = [
  { value: 'cash', label: 'Cash' },
  { value: 'transfer', label: 'Transfer' },
  { value: 'qris', label: 'QRIS' },
  { value: 'cash+transfer', label: 'Cash + Transfer' },
];

export const methodLabel = (v) => PAY_METHODS.find((m) => m.value === v)?.label || v;

// ---- Daftar Belum Lunas per bulan (bulan = bulan tanggal pakai) ----
export const bulanKey = (d) => (/^\d{4}-\d{2}/.test(d || '') ? String(d).slice(0, 7) : 'tanpa');

export const bulanLabel = (key) => {
  if (key === 'tanpa') return 'Tanpa tanggal';
  try {
    return format(parseISO(`${key}-01`), 'MMM yyyy', { locale: localeId });
  } catch {
    return key;
  }
};

// [{key, label, jumlah, sisa}] urut kronologis (tanpa tanggal paling akhir).
export const ringkasBulan = (list) => {
  const m = new Map();
  (list || []).forEach((t) => {
    const k = bulanKey(t.use_date);
    const e = m.get(k) || { key: k, label: bulanLabel(k), jumlah: 0, sisa: 0 };
    e.jumlah += 1;
    e.sisa += Number(t.remaining) || 0;
    m.set(k, e);
  });
  return [...m.values()].sort((a, b) =>
    a.key === 'tanpa' ? 1 : b.key === 'tanpa' ? -1 : a.key.localeCompare(b.key));
};

export const saringBulan = (list, key) =>
  !key ? (list || []) : (list || []).filter((t) => bulanKey(t.use_date) === key);
